import type { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { AreaGate, InicioDaArea } from '../../core/areas/AreaGate'
import { flattenNav } from '../../core/router/navConfig'
import { PlaceholderPage } from '../../shared/components/PlaceholderPage'
import { MultasPage, SinistrosPage, comPermissao } from '../../core/router/telas'
import { abastecimentoNav } from './nav'

const RAIZ = '/abastecimento'

/** Registro path → componente dos itens do menu do Abastecimento. Item sem entrada
 *  aqui cai no PlaceholderPage automaticamente. */
const PAGES: Record<string, ReactElement> = {
  '/abastecimento/multas': <MultasPage />,
  '/abastecimento/sinistros': <SinistrosPage />,
}

/** As rotas da área Abastecimento. A raiz leva à primeira tela ao alcance, como no
 *  Administrativo, e cada tela tem o portão da key que o item do menu declara. */
export function rotasDoAbastecimento(): ReactElement {
  return (
    <Route path={RAIZ} element={<AreaGate area="abastecimento" />}>
      <Route index element={<InicioDaArea area="abastecimento" />} />
      {flattenNav(abastecimentoNav).map((item) => (
        <Route key={item.path} path={item.path}
          element={comPermissao(item, PAGES[item.path] ?? <PlaceholderPage title={item.label} />)} />
      ))}
    </Route>
  )
}
